// extracted by mini-css-extract-plugin
module.exports = {"row":"TableRow-module__row--11-lB","actionable":"TableRow-module__actionable--2eBD8"};